import { currency, lang } from '@shop/utils/Translation';

export default function formatPrice(value: number): string {
  return new Intl.NumberFormat(lang, {
    style: 'currency',
    currency,
  }).format(value);
}
